import { render, staticRenderFns } from "./AddressSection.vue?vue&type=template&id=05493edc&scoped=true&"
import script from "./AddressSection.vue?vue&type=script&lang=js&"
export * from "./AddressSection.vue?vue&type=script&lang=js&"
import style0 from "./AddressSection.vue?vue&type=style&index=0&id=05493edc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05493edc",
  null
  
)

export default component.exports